import t from "../../Actions/SelfRegisterActions/types";

const initial = {
  isPinValid: 0,
  property_id: "",
  quickPermitSetupDetail: {},
  quickPermitDetail: {},
  quickPermitCreateDetail: {},
};
const reducer = (state = initial, action) => {
  switch (action.type) {
    case t.IS_PIN_VALID: {
      const test = {
        ...state,
        isPinValid: JSON.parse(JSON.stringify(action.payload)),
      };
      return { ...test };
    }
    case t.RESET_QUICK_PERMIT_DATA: {
      return {
        ...state,
        quickPermitDetail: {},
      };
    }
    case t.GET_PROPERTY_ID: {
      return {
        ...state,
        property_id: action.payload,
      };
    }
    case t.GET_QUICK_PERMIT_SETUP_DETAIL: {
      return {
        ...state,
        quickPermitSetupDetail: action.payload,
      };
    }
    case t.GET_PERMIT_DETAIL: {
      return {
        ...state,
        quickPermitDetail: action.payload,
      };
    }
    case t.GET_QUICK_PEMIT_CREATE_DATA: {
      return {
        ...state,
        quickPermitCreateDetail: action.payload,
      };
    }
    default:
      return state;
  }
};
export default reducer;
